import { InjectionToken, makeEnvironmentProviders } from '@angular/core';
import { ApiService } from './services/api.service';

export const CUE_CALENDAR_API_BASEURL: InjectionToken<string> = new InjectionToken<string>('CUE_API_BASE_URL');
export function provideCueCalendarApi(options: { factory: () => string }) {
  return makeEnvironmentProviders([
    {
      provide: CUE_CALENDAR_API_BASEURL,
      multi: false,
      useFactory: options.factory,
    },
    ApiService,
  ]);
}
